export const iconFontAwesomeSecurityUserSecret = (
	<i className="fa-solid fa-user-secret"></i>
);
